module.exports = __webpack_public_path__ + "img/dog.46fce7ec.svg";